// extracted by mini-css-extract-plugin
module.exports = {"auth__content":"SignInPin_auth__content__48VxM","pin_loading":"SignInPin_pin_loading__7vwDv","resend_button":"SignInPin_resend_button__JnqDk"};